import type { SubjectPack } from '../../pack';
import { MATH_DOMAINS } from './skills';
import { NUMBER_FAMILIES } from './gen-number';
import { ALGEBRA_FAMILIES } from './gen-algebra';
import { GEOMETRY_FAMILIES } from './gen-geometry';

export const MATH_PACK: SubjectPack = {
  subject: {
    id: 'math',
    name: 'Mathematics',
    nameNo: 'Matematikk',
    hue: 190,
    glyph: 'sigma',
    description: 'Number, algebra, functions, geometry, statistics, probability, modelling and calculus.',
    stageModel: { kind: 'grade', firstStage: 'G1' },
    curriculumIds: ['cur.mat.1-10', 'cur.mat.1T', 'cur.mat.1P', 'cur.mat.1PY', 'cur.mat.2P', 'cur.mat.R', 'cur.mat.S'],
  },
  domains: MATH_DOMAINS,
  families: [...NUMBER_FAMILIES, ...ALGEBRA_FAMILIES, ...GEOMETRY_FAMILIES],
};
